<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

    <qr-edit-gateway
      v-model="showGatewayPopup"
      :sections="specialInfoSingle"
      :form-data="data"
      @edit-all="handleEditAll"
      @save="qrUpdate(true)"
      @cancel="onCancel"
    >
    <template v-slot:preview style="position: relative; min-height: 100%;">
      <div class="sticky-preview">
          <view-menu v-model="data" :loading="loading || qrLoading" :qr-svg-data-url="qrSvgDataUrl"/>
        </div>
    </template>
    </qr-edit-gateway>

      <v-row class="mx-auto pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col class="pa-2" cols="12">
          <v-progress-linear
            v-show="loading || qrLoading"
            height="5"
            indeterminate
          />
        </v-col>

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <view-menu v-model="data" :loading="loading || qrLoading" :qr-svg-data-url="qrSvgDataUrl"/>
        </v-col>

        <v-col cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>{{ $t("enter_menu_information") }}</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="res.title"
                        :disabled="e6 > 1"
                        :label="$t('online_menu_name')"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-title`"
                        :help-data="helpData"
                        :label="$t('online_menu_name_short')"
                        :service-name="serviceName"
                        class="buttoninfo"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        ref="address-field"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        outlined
                        persistent-hint
                        readonly
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :help-data="helpData"
                        :service-name="serviceName"
                        class="buttoninfo"
                        :label="$t('qr_address')"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <v-card-actions class="justify-end"  v-if="data && data.product">
                  <v-switch
                    v-model="data.product.onlineShop"
                    :label="$t('online_sales')"
                    class="ma-0"
                    dense
                    hide-details
                    inset
                  />
                </v-card-actions>
                  <div class="mb-4 mx-4">
                    <!-- سوییچ و آیکون راهنما -->
                    <div class="d-flex align-center">
                      <v-switch
                        v-model="AutoSave"
                        color="primary"
                        class="mt-0 pt-0 shrink"
                        hide-details
                        label="ذخیره خودکار"
                      ></v-switch>

                      <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                      <v-tooltip bottom max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            class="mr-1"
                            v-bind="attrs"
                            v-on="on"
                            @click.stop
                          >
                            <v-icon small color="grey darken-1">
                              mdi-help-circle-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>
                          تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                        </span>
                      </v-tooltip>
                    </div>

                    <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                    <div
                      v-if="$vuetify.breakpoint.xsOnly"
                      class="text-caption grey--text text--darken-1 mt-1 pr-1"
                      style="line-height: 1.4"
                    >
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </div>
                  </div>

                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"

                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true);
                    e6++;
                  if(!data?.product?.onlineShop)
                      goTo('qr/list')" 
                  />
                </div>
              </v-stepper-content>

              <v-stepper-step
                v-if="!!data && !!data.product && data.product.onlineShop"
                :complete="e6 > 2"
                class="px-0 px-md-4"
                step="2"
              >
                {{ $t("sales_settings") }}
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
                <qr-shop-manager
                  ref="qrShop"
                  :domain="domainName"
                  :loading.sync="loading"
                  :qr-id="qrId"
                  @save-required="AutoSave && qrUpdate(false)" />

                <div class="row mx-auto">
                  <div class="col-md-6">
                    <prev-btn :loading="loading" @click="e6 = 1" />
                  </div>

                  <div class="col-md-6">
                    <next-btn :loading="loading" @click="updateShopSettings" />
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import ViewMenu from "./cm/viewMenu.vue";
import QrAddressField from "../../../content/fragments/qrAddressField";
import ListExpansion from "../../../content/fragments/listExpansion";
import NextBtn from "../../../content/fragments/nextBtn";
import QrManagement from "../../qrland/components/qrManage/qrManagement";
import PrevBtn from "../../../content/fragments/prevBtn";
import { mapActions } from "vuex";
import QrShopManager from "@/view/pages/qrland/components/qrManage/manageShop/qrShopManager.vue";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import { data } from "jquery";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "editMenu",

  components: {
    QrShopManager,
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    ViewMenu,
    QrEditGateway,
    AtomSpinner
  },

 provide() {
    return {
      productImageSize: "128",
      getMenuCurrency: () => this.selectedCurrency
  }
},
  data() {
    return{
      qrSvgDataUrl:'',
      isAutoSaving: false, 
      AutoSave:false,
      selectedCurrency:'ریال',
      orders: [],
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      helpData: [],
      serviceName: "Qrland",
      componentName: "editMenu",
      data: {},
      e6: 1,
      errors: {},
      loading: false,
      res: {},
      qrLoading: false,
    }
  },

  mounted() {
    this.fetchData();
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
  },

  computed: {
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    computedSteps() {
      return [{ step: this.data.product?.onlineShop ? 4 : 3, value: "setting" }];
    },
    specialInfo() {
      return [
           {
        name: "ThemeSelector2",
        value: "",
        title: this.$t('select_template_design'),
        subtitle: "",
        icon: "card-account-details-star-outline",
        model: "ThemeSelector2"
      
      },
         {
          name: "shopLoginConfig",
          value: "",
          title: this.$t("shop.login_settings"),
          subtitle: "",
          icon: "home-import-outline",
          model: "shopLoginConfig",
          tabs: [
            {
              title: this.$t("shop.store_logo_images"),
              icon: "mdi-cards-playing-heart-outline",
              component: "shopLogo_menu",
              model: "shopLogo",
            },
            {
              title: this.$t("shop.login_page_info"),
              icon: "mdi-view-carousel-outline",
              component: "shopLoginConfig",
              model: "configs",
            },
          ],
        },
         {
        name: "GeneralSettings",
        value: "",
        title: this.$t('general_menu_settings'),
        subtitle: "",
        icon: "cog-outline",
        model: "settings"
      
      },
        {
          name: "bannerSelector",
          value: "",
          title: this.$t("shop.upload_banner"),
          subtitle: "",
          icon: "image-area",
          model: "banner",
        },
        {
          name: "Product",
          value: "",
          title: this.$t("shop.create_product"),
          subtitle: "",
          icon: "sign-yield",
          model: "product",
        },
        {
          name: "textCards",
          value: "",
          title: this.$t("shop.user_info"),
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t("shop.add_social_media"),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "PicSelector",
          value: "",
          title: this.$t("shop.photo_gallery"),
          subtitle: "",
          icon: "image-outline",
        },
        {
          name: "VideoGallery",
          value: "",
          title: this.$t("shop.video_gallery"),
          subtitle: "",
          icon: "video-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: this.$t("shop.feedback"),
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "WorkSheet",
          value: "",
          title: this.$t("shop.working_hours"),
          subtitle: "",
          icon: "timetable",
          model: "WorkSheet",
        },
      ];
    },
    specialInfoSingle() {
    return [
      {
        name: "ThemeSelector2",
        value: "",
        title: this.$t("select_template_design"),
        subtitle: "",
        icon: "card-account-details-star-outline",
        model: "ThemeSelector2",
        description: this.$t(
          "edit_menu_special_info_single.theme_info_single.theme_selector_description"
        ),
      },
      {
        name: "shopLogin",
        value: "",
        title: this.$t("shop.login_settings"),
        subtitle: "",
        icon: "home-import-outline",
        model: "shopLoginConfig",
        description: this.$t(
          "edit_menu_special_info_single.login_config_description"
        ),
        tabs: [
          {
            title: this.$t("shop.store_logo_images"),
            icon: "mdi-cards-playing-heart-outline",
            component: "shopLogo_menu",
            model: "shopLogo",
          },
          {
            title: this.$t("shop.login_page_info"),
            icon: "mdi-view-carousel-outline",
            component: "shopLoginConfig",
            model: "configs",
          },
        ],
      },

      {
        name: "GeneralSettings",
        value: "",
        title: this.$t("general_menu_settings"),
        subtitle: "",
        icon: "cog-outline",
        model: "settings",
        description: this.$t(
          "edit_menu_special_info_single.general_settings_description"
        ),
      },

      {
        name: "bannerSelector",
        value: "",
        title: this.$t("shop.upload_banner"),
        subtitle: "",
        icon: "image-area",
        model: "banner",
        description: this.$t(
          "edit_menu_special_info_single.banner_selector_description"
        ),
      },

      {
        name: "Product",
        value: "",
        title: this.$t("shop.create_product"),
        subtitle: "",
        icon: "sign-yield",
        model: "product",
        description: this.$t(
          "edit_menu_special_info_single.product_description"
        ),
      },

      {
        name: "textCards",
        value: "",
        title: this.$t("shop.user_info"),
        subtitle: "",
        icon: "account-outline",
        description: this.$t(
          "edit_menu_special_info_single.text_cards_description"
        ),
      },

      {
        name: "socialMediaIcons",
        value: "",
        title: this.$t("shop.add_social_media"),
        subtitle: "",
        icon: "instagram",
        model: "socialMedia",
        description: this.$t(
          "edit_menu_special_info_single.social_media_description"
        ),
      },

      {
        name: "PicSelector",
        value: "",
        title: this.$t("shop.photo_gallery"),
        subtitle: "",
        icon: "image-outline",
        description: this.$t(
          "edit_menu_special_info_single.photo_gallery_description"
        ),
      },

      {
        name: "VideoGallery",
        value: "",
        title: this.$t("shop.video_gallery"),
        subtitle: "",
        icon: "video-outline",
        description: this.$t(
          "edit_menu_special_info_single.video_gallery_description"
        ),
      },

      {
        name: "FeedBack",
        value: "",
        title: this.$t("shop.feedback"),
        subtitle: "",
        icon: "reply-outline",
        model: "FeedBack",
        description: this.$t(
          "edit_menu_special_info_single.feedback_description"
        ),
      },

      {
        name: "WorkSheet",
        value: "",
        title: this.$t("shop.working_hours"),
        subtitle: "",
        icon: "timetable",
        model: "WorkSheet",
        description: this.$t(
          "edit_menu_special_info_single.working_hours_description"
        ),
      },
    ];
  },

  },

  watch: {
      "data.settings.currency": {
      handler(val) {
        if (!!val) {
          this.selectedCurrency = val;
        }
      },
      immediate: true, 
    },

    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),
    onCancel() {
      this.goto('qr/list');
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      this.qrLoading = true;

      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`,
        )
        .then(({ data }) => {
          let info = data.data.data;
          this.qrSvgDataUrl= data?.data?.img_url||''; 
          this.res = data.data;
          if(!info.data.ThemeSelector2)
            {
              info.data.ThemeSelector2 = {
                theme: 'theme_1'
              };
            }
            if (!info.data.settings) {
            info.data.settings = {
              businessType: 'restaurant',
              showCategories:true,
              currency: 'ریال',
              showFilter: true,
              customLabels: { productsTitle: '', cartButton: '' }
            };
          } else if (!info.data.settings.customLabels) {
            info.data.settings.customLabels = { productsTitle: '', cartButton: '' };
          }
           if (!info.data.shopLoginConfig) {
        info.data.shopLoginConfig = {
          shopLogo: [
            {
              value: "logo",
              name: this.$t("image_logo"),
              logo: "",
            },
            {
              value: "background",
              name: this.$t("background_image"),
              background: "",
            },
          ],
          configs: {
            subtitle: "",
          },
        };
      }
          // fix product
          if (!Object.hasOwn(info.data.product, "onlineShop")) {
            info.data.product.onlineShop = true;
            this.$nextTick(() => {
              this.$refs.qrShop?.fetchSettings();
              this.$refs.qrShop?.fetchTables();
            });
          } else if (info?.data?.product?.onlineShop) {
            this.$nextTick(() => {
              this.$refs.qrShop?.fetchSettings();
              this.$refs.qrShop?.fetchTables();
            });
          }

          this.data = info.data;
          this.setCreatedQrID(data.data.id);
          this.updateQrId(data.data.id);
          this.updateQridentifier(data.data.identifier);
          this.setQrType(data.data.type);
        })
        .finally(() => (this.qrLoading = false));
    },
    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "menu");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);
      data.append("_method", "PUT");
      this.data.language = getLanguageCookie() ? getLanguageCookie() : "fa";

      data.append(
        "data",
        JSON.stringify({
          theme: this.data.ThemeSelector2.theme,
          data: this.data,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then(({ data }) => {
          if(final|| this.isAutoSaving)
              this.$toast.success(
                this.$t("create_menu.messages.qr_updated_success"),
              );
          this.$root.$emit("submitFeedback");
          // if (this.data?.product?.onlineShop) {
          //   this.e6++;
          // } else this.$router.replace({ name: "qr.list" });
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
            this.loading = false;
            this.isAutoSaving = false;
        });
    },
    async updateShopSettings() {
      this.loading = true;
      await this.$refs.qrShop
        .setCartSetting()
        .then((data) => this.e6++)
        .finally(() => {
          this.setTableReservation();
          this.setShopNotice();
          setTimeout(() => {
            this.$router.replace({ name: "qr.list" });
          }, 500);
            this.loading = false;
            this.isAutoSaving = false;

        });
    },
    async setTableReservation() {
      await this.$refs.qrShop.setTableReservation();
    },
    async setShopNotice() {
      await this.$refs.qrShop.setShopNotice();
    },
    async setSettings() {
      const res = await this.$refs.qrManage.update();
      await this.$router.replace({ name: "qr.list" });
    },
  },
};
</script>

<style scoped></style>
